import React from 'react'
import {FormattedMessage} from 'react-intl'
import {Text} from '@chakra-ui/react'
import {useCurrentBasket} from '_customHooks'

const MinicartHeader = () => {
    // Read-only consumer: use the light useCurrentBasket (same query, no 11 mutation hooks / effects),
    // consistent with topbar-right. basketProductsCount derives from c_productsQuantity (default 0).
    const {data: basket} = useCurrentBasket()
    const basketProductsCount = basket?.c_productsQuantity ?? 0

    return (
        <Text as="span" data-testid="minicart-header-title">
            <FormattedMessage id="label.num.items" defaultMessage="Your selection ( {0} )" values={{0: basketProductsCount}} />
        </Text>
    )
}

export {MinicartHeader}
